import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan, faEye } from "@fortawesome/free-solid-svg-icons";
import {
  toUploadFile,
  uploadDocumentlistData,
  handleDeleteDocumentAPI,
  getTransactionDocumentData,
} from "../../services/api/user";
import Upload from "../../assets/images/upload.svg";
import { formatDateWithdash } from "../../Utils/common";
import {
  Baseurl,
  checkIfPDFIsEncrypted,
  checkMaliciousPdf,
  DocsBaseUrl,
  GetLocalStorage,
  GetLocalStorageParsed,
  isDisallowedFileType,
  PdfBaseUrl,
} from "../../Utils/Utils";
import { SuccessModal } from "../Modal/SuccessModal";
import { useLanguage } from "../LanguageProvider/LanguageProvider ";

const DocsUpload = ({
  subCatId,
  docErrors,
  setDocErrors,
  documentList,
  setDocumentList,
  parentApplicationId,
  applicationDistrictId,
  docsList,
  getTransactionDoc,
  alreadyPayed,
  setAlreadyPayed,
  transactionDocument,
  setTransactionDocument,
  checkAlreadyPayed,
  setCheckAlreadyPayed,
  applicationPaymentDocuemntRejected,
  applicationLastUpdatedDate,
  enableAlreadyPayed
}) => {
  const { language, setLanguage } = useLanguage();
  const loginCatInfo = GetLocalStorageParsed("LoginSubCatData");
  const [baseUrl, setBaseUrl] = useState([]);
  const [modalShow, setModalShow] = useState(false); // State to show/hide the modal
  const [modalMessage, setModalMessage] = useState(""); // Modal message
  const [modalHeaderMsg, setModalHeaderMsg] = useState("");
  const [fileId, setFileId] = useState();
  const [docDetails, setDocDetails] = useState();
  const applicationId = GetLocalStorage("application_id");
  const [fileErrors, setFileErrors] = useState({});

  const fileTypeList = [
    { label: "Docx", value: "1", accept: ".docx", mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document" },
    { label: "PDF", value: "2", accept: ".pdf", mimeType: "application/pdf" },
    { label: "Xlsx", value: "3", accept: ".xlsx", mimeType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" },
    { label: "Pptx", value: "4", accept: ".pptx", mimeType: "application/vnd.openxmlformats-officedocument.presentationml.presentation" },
    { label: "Txt", value: "5", accept: ".txt", mimeType: "text/plain" },
    { label: "Csv", value: "6", accept: ".csv", mimeType: "text/csv" },
    { label: "Png/Jpg/Jpeg/PDF", value: "7", accept: ".png,.jpg,.jpeg,.pdf", mimeType: "image/png, image/jpeg, application/pdf" }
    // { label: "Png", value: "8", accept: ".png" },
  ];

  useEffect(() => {
    setCheckAlreadyPayed(alreadyPayed)
    setBaseUrl(Baseurl);
    if (applicationPaymentDocuemntRejected && transactionDocument && applicationLastUpdatedDate && alreadyPayed) {
      // Convert both dates to Date objects
      const createdAtDate = new Date(transactionDocument?.updated_at); // ISO 8601 format (UTC)
      const updatedAtDate = new Date(applicationLastUpdatedDate); // Local format (make sure it's a valid date string)
    
      // Compare the two dates
      if (updatedAtDate > createdAtDate) {
        setDocErrors((prevErrors) => ({
          ...prevErrors,
          ["0"]: {
            hi: `आपका आवेदन DTDO द्वारा अमान्य भुगतान दस्तावेज़ के कारण अस्वीकार कर दिया गया था। कृपया वर्तमान दस्तावेज़ हटाएँ और मान्य दस्तावेज़ अपलोड करें या नया भुगतान सबमिट करें।`,
            en: `Your application was rejected by DTDO due to an invalid payment document. Please remove the current document and upload a valid one or submit a new payment.`,
          },
        }));
      }
    }
  }, []);

  

  const handleFileChange = (isTransactionDocument, doc, index) => async (e) => {
    const uploadedFile = e.target.files[0];
    const fileType = fileTypeList.find((x) => x.label === doc?.type);

    // Validate file type
    if (
      fileType &&
      fileType.accept &&
      !fileType.accept.includes(uploadedFile?.type?.split("/")[1]?.toString()?.toLowerCase()) &&
      !fileType.mimeType.includes(uploadedFile?.type?.split("/")[1]?.toString()?.toLowerCase())
    ) {
      setFileErrors((prevErrors) => ({
        ...prevErrors,
        [isTransactionDocument === "1" ? "0" : doc?.id]: language
          ? `अमान्य फ़ाइल प्रकार.केवल ${doc?.type} फ़ाइलों की अनुमति है।`
          : `Invalid file type. Only ${doc?.type} files are allowed.`,
      }));
      return;
    }

    const maxSizeInBytes = isTransactionDocument === "1" ? 2000 * 1024 : parseInt(doc?.size) * 1024;
    if (isNaN(maxSizeInBytes) && isTransactionDocument === "0") {
      return;
    }

    if (uploadedFile.size == 0) {
      setFileErrors((prevErrors) => ({
        ...prevErrors,
        [isTransactionDocument === "1" ? "0" : doc?.id]: language
          ? `अमान्य फ़ाइल आकार। 0 Kb फ़ाइलों की अनुमति नहीं है।`
          : `Invalid file size. 0 Kb files are not allowed.`,
      }));
      return;
    }

    if (uploadedFile.size > maxSizeInBytes) {
      setFileErrors((prevErrors) => ({
        ...prevErrors,
        [isTransactionDocument === "1" ? "0" : doc?.id]: language
          ? `अमान्य फ़ाइल आकार. केवल ${isTransactionDocument === "1" ? 2 : doc?.size / 1000
          } एमबी फ़ाइलों की अनुमति है।`
          : `Invalid file size. Only ${isTransactionDocument === "1" ? 2 : doc?.size / 1000} MB files are allowed.`,
      }));
      return;
    }

    if (uploadedFile) {
      const isDisallowedFile = await isDisallowedFileType(uploadedFile);
      
      if (isDisallowedFile) {
        setFileErrors((prevErrors) => ({
          ...prevErrors,
          [isTransactionDocument === "1" ? "0" : doc?.id]: language
            ? `कृपया एक वैध फ़ाइल अपलोड करें।`
            : `Invalid file. Please upload a valid file.`,
        }));
        return;
      }

      const isEncrypted = await checkIfPDFIsEncrypted(uploadedFile);

      if (isEncrypted) {
        setFileErrors((prevErrors) => ({
          ...prevErrors,
          [isTransactionDocument === "1" ? "0" : doc?.id]: language
            ? `यह फ़ाइल पासवर्ड द्वारा सुरक्षित है। कृपया किसी और फ़ाइल से कोशिश करें।`
            : `This file is encrypted with password. Please try again with different file.`,
        }));
        return;
      }

      const isValidFile = await checkMaliciousPdf(uploadedFile);

      if (isValidFile) {
        setFileErrors((prevErrors) => ({
          ...prevErrors,
          [isTransactionDocument === "1" ? "0" : doc?.id]: language
            ? `कृपया एक वैध फ़ाइल अपलोड करें।`
            : `Invalid file. Please upload a valid file.`,
        }));
        return;
      }
    }

    try {
      const formData = new FormData();
      formData.append("upload_doc", uploadedFile);
      formData.append("upload_date", formatDateWithdash(new Date()));
      formData.append("category_id", loginCatInfo?.id);
      formData.append("document_type_id", isTransactionDocument === "1" ? "0" : doc?.id);

      formData.append("application_id", applicationId);
      if(isTransactionDocument === "1") {
        formData.append(
          "upload_document_id",
          transactionDocument && transactionDocument?.id 
            ? transactionDocument?.id
            : ""
        );
      } else {
        formData.append(
          "upload_document_id",
          doc?.upload_documents[0] && doc?.upload_documents[0].id
            ? doc?.upload_documents[0].id
            : ""
        );
      }
      formData.append("district_id", applicationDistrictId);
      formData.append("is_transaction_document", isTransactionDocument);
      const data = await toUploadFile(formData);
      if (data?.success === true) {
        if(isTransactionDocument === "1") {
          await getTransactionDoc();
          setAlreadyPayed(true)
        } else {
          await docsList();
        }
        setModalMessage(language ? "दस्तावेज़ अपलोड किया गया" : `Document uploaded`);
        setModalHeaderMsg("false");
        setModalShow(true);
        setDocErrors((prevErrors) => ({
          ...prevErrors,
          [isTransactionDocument === "1" ? "0" : doc?.id]: null,
        }));

        setFileErrors((prevErrors) => {
          const updatedErrors = { ...prevErrors };
          delete updatedErrors[isTransactionDocument === "1" ? "0" : doc?.id];
          return updatedErrors;
        });
      } else {
        if(data?.data?.upload_doc) {
          setFileErrors((prevErrors) => ({
            ...prevErrors,
            [isTransactionDocument === "1" ? "0" : doc?.id]: language
              ? `कृपया एक वैध फ़ाइल अपलोड करें।`
              : `Invalid file. Please upload a valid file.`,
          }));
        } else {
          setFileErrors((prevErrors) => ({
            ...prevErrors,
            [isTransactionDocument === "1" ? "0" : doc?.id]: language
              ? `फ़ाइल अपलोड करते समय समस्या।`
              : `Error updating the file.`,
          }));
        }
        setModalHeaderMsg("");
        setModalShow(false);
      }
    } catch (error) {
      //console.error(error.message);
      setModalMessage(error.message);
      setModalHeaderMsg("");
      setModalShow(false);
    }
  };

  const handleDeleteDocument = async () => {
    try {
      const payload = {
        upload_document_id:
           docDetails.upload_documents[0] && docDetails.upload_documents[0].id
            ? docDetails.upload_documents[0].id
            : "",
      };
      const data = await handleDeleteDocumentAPI(payload);
      if (data?.status === 200) {
        if(docDetails?.required === "1") {
          setDocErrors((prevErrors) => ({
            ...prevErrors,
            [docDetails?.id]: {
              hi: `${docDetails?.name_hi} आवश्यक है`,
              en: `${docDetails?.name_en} is required`,
            },
          }));
        }
        docsList();
      }
    } catch (error) {
      //console.error(error.message);
    }
  };

  const handleDeleteTransactionDocument = async () => {
    try {
      const payload = {
        upload_document_id:
           docDetails && docDetails?.id
            ? docDetails?.id
            : "",
      };
      const data = await handleDeleteDocumentAPI(payload);
      if (data?.status === 200) {
        await getTransactionDoc();
        setAlreadyPayed(false)
        setCheckAlreadyPayed(false)
        setDocErrors((prevErrors) => ({
          ...prevErrors,
          ['0']: {
            hi: `भुगतान दस्तावेज़ आवश्यक है`,
            en: `Payment Document is required`,
          },
        }));
      }
    } catch (error) {
      //console.error(error.message);
    }
  };

  const validateDocuments = () => {
    const newErrors = {};
    documentList.forEach((doc, index) => {
      if (!doc.upload_documents || doc.upload_documents.length === 0) {
        newErrors[doc?.id] = language ? "फ़ाइल आवश्यक है" : "File is required";
      }
    });
    setFileErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Returns true if no errors
  };

  const extractPath = (path) => {
    const segments = path.split('/');
    return `${segments[1]}/${segments[2]}/${segments[3]}`; // Combine them into one string
  };

  return (
    <div className="">
      <div className="row mt-2" style={{ opacity: applicationPaymentDocuemntRejected ? 0.5 : 1, pointerEvents: applicationPaymentDocuemntRejected ? "none" : "auto" }}>
        {documentList?.map((doc, index) => { 
          return (
            <>
          <div className="col-lg-6 col-md-12 col-sm-12" key={index}>
            <div
              className="documents_block"
              style={
                docErrors?.[doc?.id]
                  ? { margin: "0 0 0px" }
                  : { margin: "0 0 24px" }
              }
            >
              <div className="documents_detail w-100">
                <h5 className="mb-0">
                  <span className={doc?.required === "1" ? "en-label" : `st-lable`}>
                    {index + 1}. {language ? doc?.name_hi : doc?.name_en}
                  </span>
                </h5>
                <div className="upload-document-text">
                  {doc.upload_documents[0] && doc.upload_documents[0].filename
                    ? doc.upload_documents[0].filename
                    : ""}
                </div>
                {fileErrors[doc?.id] && (
                  <div className="validate-error">{fileErrors[doc?.id]}</div>
                )}
              </div>

              <div className="upload-icons d-flex align-items-end flex-column justify-content-end w-100">
                <div className="u_inner_icons d-flex mb-2">
                  <label
                    htmlFor={`general_certificate_${index}`}
                    className="upload-label"
                  >
                    <div className="doc-icon upload file_need_to_be_upload">
                      <div className="doc-icon upload-icon preview">
                        <img src={Upload} alt="Upload Icon" />
                      </div>
                    </div>
                    <input
                      id={`general_certificate_${index}`}
                      type="file"
                      className="upload_document form-control upload-doc"
                      accept={
                        fileTypeList.find((x) => x.label === doc?.type)
                          ?.accept || ""
                      }
                      required
                      onChange={(e) => {
                        handleFileChange("0", doc, index)(e);
                        e.target.value = null; // Reset input value to allow re-selection of the same file
                      }}
                      style={{ display: "none" }}
                    />
                  </label>

                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      if (
                        doc.upload_documents[0] &&
                        doc.upload_documents[0].path
                      ) {
                        // const folder_path = extractPath(doc?.upload_documents[0]?.path)
                        // window.open(`${DocsBaseUrl()}/${folder_path}/${doc?.upload_documents[0]?.filename}`);
                        window.open(
                          baseUrl + "/" + doc.upload_documents[0].path,
                          "_blank"
                        );
                      } else {
                        alert("No preview available.");
                      }
                    }}
                  >
                    <div className="doc-icon preview-icon delete">
                      <FontAwesomeIcon icon={faEye} />
                    </div>
                  </a>
                  <a>
                    <div
                      className="doc-icon del-icon preview"
                      // onClick={(e) => handleDeleteDocument(doc, index)(e)}
                      onClick={() => {
                        if (doc.upload_documents.length > 0) {
                          setModalShow(true);
                          setModalMessage(
                            language ? "क्या आपको यकीन है" : "Are you sure"
                          );
                          setModalHeaderMsg("true");
                          setFileId(index);
                          setDocDetails(doc);
                        } else {
                          setModalShow(false);
                        }
                      }}
                    >
                      <FontAwesomeIcon icon={faTrashCan} />
                    </div>
                  </a>
                </div>

                <div className="instructions">
                  <p className="mb-0 pdf-support">
                    {language
                      ? `(केवल ${doc?.type} अपलोड करें)`
                      : `(Only ${doc?.type} upload)`}
                  </p>
                  <p className="mb-0 file-size text-end">
                    {language
                      ? `फाइल साइज मैक्सिमम ${doc?.size / 1000} मब`
                      : ` File Size Maximum ${doc?.size / 1000} MB`}
                  </p>
                </div>
              </div>
            </div>
            {docErrors?.[doc?.id] ? (
              <div className="validate-error" style={{ margin: "0 0 24px" }}>
                {language ? docErrors?.[doc?.id]?.hi : docErrors?.[doc?.id]?.en}
              </div>
            ) : (
              <></>
            )}
          </div>
      </>)})}
      </div>
      <div className="row mt-2" style={{ opacity: enableAlreadyPayed ? 1 : 0.5, pointerEvents: enableAlreadyPayed ? "auto" : "none" }}>
        <div className="form-group mb-3">
            <input
              type="checkbox"
              id="condition1"
              checked={checkAlreadyPayed}
              className="mx-2"
              onChange={() => {
                setCheckAlreadyPayed(!checkAlreadyPayed)
                setDocErrors((prevErrors) => ({
                  ...prevErrors,
                  ["0"]: null,
                }));
              }}
              disabled={alreadyPayed}
            />
            <label htmlFor="condition1">
              {language ? `क्या आपने पहले ही भुगतान कर दिया है? या आपके पास कोई प्रमाण पत्र है। (कृपया भुगतान रसीद या प्रमाण पत्र संलग्न करें)।` : `Already paid? Or have a certificate. (Please attach payment receipt or certificate.)`}
            </label>
        </div>
        {alreadyPayed || checkAlreadyPayed ? <div className="col-lg-6 col-md-12 col-sm-12">
        <div
          className="documents_block"
          style={
            docErrors?.[transactionDocument?.id]
              ? { margin: "0 0 0px" }
              : { margin: "0 0 10px" }
          }
        >
          <div className="documents_detail w-100">
            <h5 className="mb-0">
              <span className="en-label">
                {language ? "भुगतान दस्तावेज़ अपलोड करें" : "Upload Payment Document"}
              </span>
            </h5>
            <div className="upload-document-text">
              {transactionDocument && transactionDocument?.filename
                ? transactionDocument?.filename
                : ""}
            </div>
            {fileErrors["0"] && (
              <div className="validate-error">{fileErrors["0"]}</div>
            )}
          </div>

          <div className="upload-icons d-flex align-items-end flex-column justify-content-end w-100">
            <div className="u_inner_icons d-flex mb-2">
              <label
                htmlFor={`trasaction_document`}
                className="upload-label"
              >
                <div className="doc-icon upload file_need_to_be_upload">
                  <div className="doc-icon upload-icon preview">
                    <img src={Upload} alt="Upload Icon" />
                  </div>
                </div>
                <input
                  id={`trasaction_document`}
                  type="file"
                  className="upload_document form-control upload-doc"
                  accept=".pdf,.png,.jpg,.jpeg"
                  required
                  onChange={(e) => {
                    handleFileChange("1", transactionDocument, 1)(e);
                    e.target.value = null; // Reset input value to allow re-selection of the same file
                  }}
                  style={{ display: "none" }}
                />
              </label>

              <a
                onClick={(e) => {
                  e.preventDefault();
                  if (
                    transactionDocument &&
                    transactionDocument?.path
                  ) {
                    // const folder_path = extractPath(transactionDocument?.path)
                    // window.open(`${DocsBaseUrl()}/${folder_path}/${transactionDocument?.filename}`);
                    window.open(
                      baseUrl + "/" + transactionDocument?.path,
                      "_blank"
                    );
                  } else {
                    alert("No preview available.");
                  }
                }}
              >
                <div className="doc-icon preview-icon delete">
                  <FontAwesomeIcon icon={faEye} />
                </div>
              </a>
              <a>
                <div
                  className="doc-icon del-icon preview"
                  onClick={() => {
                    if (transactionDocument) {
                      setModalShow(true);
                      setModalMessage(
                        language ? "क्या आपको यकीन है" : "Are you sure"
                      );
                      setModalHeaderMsg("true");
                      setFileId(1);
                      setDocDetails(transactionDocument);
                    } else {
                      setModalShow(false);
                    }
                  }}
                >
                  <FontAwesomeIcon icon={faTrashCan} />
                </div>
              </a>
            </div>

            <div className="instructions">
              <p className="mb-0 pdf-support">
                {language
                  ? `(केवल Png/Jpg/Jpeg/PDF अपलोड करें)`
                  : `(Only Png/Jpg/Jpeg/PDF upload)`}
              </p>
              <p className="mb-0 file-size text-end">
                {language
                  ? `फाइल साइज मैक्सिमम 2 मब`
                  : ` File Size Maximum 2 MB`}
              </p>
            </div>
          </div>
        </div>
        {docErrors?.["0"] ? (
          <div className="validate-error fs-6" style={{ margin: "0 0 24px" }}>
            {language ? docErrors?.["0"]?.hi : docErrors?.["0"]?.en}
          </div>
        ) : (
          <></>
        )}
        </div> : <></>}
      </div>
      
      {modalShow && (
        <SuccessModal
          className="modalClass"
          show={modalShow}
          onHide={() => setModalShow(false)}
          message={modalMessage}
          handleDelete={docDetails?.is_transaction_document === "1" ? handleDeleteTransactionDocument : handleDeleteDocument}
          headerMsg={modalHeaderMsg}
        />
      )}
    </div>
  );
};

export default DocsUpload;
